import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import MerchantList from './MerchantList';
import { Button } from '@mui/material';
import { Pagination } from '@mui/material';

function MerchantSearch(props) {
    const [searchText, setSearchText] = useState(props.searchText);
    const [searchItem, setSearchItem] = useState({
        showNearest: true,
        filterText: props.searchText,
        page: props.page
    });
    const [page, setPage] = useState(props.page);

    const searchButtonClick = (e) => {
        e.preventDefault();
        const sItem = {
            showNearest: false,
            filterText: searchText,
            page: 1
        };
        setSearchItem(sItem)
        props.onSearch(sItem);
    };

    const showNearestButtonClick = (e) => {
        e.preventDefault();
        const sItem = {
            showNearest: true,
            filterText: '',
            page: 1
        };
        setSearchText('');
        setSearchItem(sItem)
        props.onSearch(sItem);
    };

    const handleChange = (event, value) => {
        setPage(value);
        const sItem = {
            showNearest: (searchText===''),
            filterText: searchText,
            page: value
        };
        setSearchItem(sItem)
        props.onSearch(sItem);
    };

    const searchTextChange = (e) => {
        setSearchText(e.target.value);
    };

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12} lg={12} md={12} xl={12} style={{ textAlign: 'center' }}>
                    <Paper
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 300, margin: 'auto', marginBottom: 2 }}
                    >
                        <InputBase
                            key={`txt-1`}
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="جستجوی پذیرندگان"
                            inputProps={{ 'aria-label': 'جستجوی پذیرندگان' }}
                            onChange={searchTextChange}
                            value={searchText}
                        />
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <IconButton type="submit" sx={{ p: '10px' }} aria-label="search" onClick={searchButtonClick}>
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={12} lg={12} md={12} xl={12} sx={{ margin: 'auto', marginBottom: 2 }}>
                    <Button variant="contained" startIcon={<AddLocationIcon />} onClick={showNearestButtonClick} sx={{
                        margin: 'auto', width: 300, marginBottom: 2, marginRight: 3.4, p: '8px 4px', bgcolor: '#db5726',
                        '&:hover': {
                            backgroundColor: '#fc7952',
                            color: '#000000',
                        }
                    }} >
                        نمایش پذیرندگان نزدیک
                    </Button>
                </Grid>
                <Grid item xs={12} sm={12} lg={12} md={12} xl={12}>
                    <MerchantList merchantMarkers={props.merchantMarkers} handleDialogOpen={(merchant)=>props.handleDialogOpen(merchant)}/>
                    <Pagination count={(Math.ceil(props.merchantMarkersCount / 5))} page={page} onChange={handleChange} style={{ margin: 'auto', direction: 'ltr', marginTop: '10px' }} />
                </Grid>
            </Grid>
            
        </>
    );
}

export default MerchantSearch;